module.exports = __webpack_public_path__ + "img/21.359252c1.jpg";